// extracted by mini-css-extract-plugin
export default {"basicSettingsStyles_checkbox":"BasicSettings_basicSettingsStyles_checkbox__SfMkk","basicSettingsStyles_checkboxAndInput":"BasicSettings_basicSettingsStyles_checkboxAndInput__uWvkd"};